import * as React from 'react';
import {View} from 'react-native';
import {Props} from './model';
import {useStyles} from '../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {Text} from '../../../../shared/components/text';

export default ({wrapperStyle, congratulationMessage}: Props) => {
  const styles = useStyles(({theme, mediaOnly}) => ({
    title: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          ...theme.fonts.h2,
          marginBottom: 30,
        },
        {
          ...theme.fonts.h6,
          marginBottom: 46,
        },
      ),
      color: theme.color.primaryColor,
      textAlign: 'center',
    },
    subtitle: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, theme.fonts.body),
      textAlign: 'center',
    },
  }));
  return (
    <View style={wrapperStyle}>
      <Text style={styles.title}>Спасибо за прохождение опроса!</Text>
      <Text style={styles.subtitle}>{congratulationMessage}</Text>
    </View>
  );
};
